import Flickity from 'flickity';
import { createSCarousel } from './carousel';

/**
 * *******************************
 * Services Filter
 * *******************************
 */
class ServiceFilter {
    constructor(block) {
        this.block = block;
        this.filterContainer = block.querySelector('.filter-container');
        if (!this.filterContainer) return;

        this.filterItems = this.filterContainer.querySelectorAll('.filter-item');
        this.filterLinks = this.filterContainer.querySelectorAll('.filter-item a');
        this.mobileSelect = this.filterContainer.querySelector('select');
        this.serviceCards = block.querySelectorAll('.service-card');
        this.carouselContainer = block.querySelector('.services-carousel-container');
        this.flickityInstance = null;

        if (!this.serviceCards.length) return;

        this.allServices = this.initializeServices();
        this.addListeners();
        this.initCarousel();
    }

    initializeServices() {
        return Array.from(this.serviceCards).map(card => {
            const gridCol = card.closest('.grid__col-sm-6, .grid__col-md-4, .grid__col-lg-3');
            return {
                element: gridCol || card.parentElement,
                cardElement: card,
                category: card.dataset.category || 'all',
            };
        });
    }

    normalizeCategory(cat) {
        if (!cat) return 'all';
        return cat.toLowerCase().replace(/\s+/g, '-').replace(/&/g, '').replace(/[^a-z0-9-]/g, '');
    }

    updateActiveFilter(category) {
        this.filterItems.forEach(item => {
            const link = item.querySelector('a');
            const itemCategory = link.dataset.category || 'all';
            item.classList.toggle('active', itemCategory === category);
        });

        if (this.mobileSelect) {
            this.mobileSelect.value = category;
        }
    }

    getFilteredServices(category) {
        if (category === 'all') return this.allServices;

        const normalizedCategory = this.normalizeCategory(category);
        return this.allServices.filter(service => {
            const serviceCategory = this.normalizeCategory(service.category);
            return serviceCategory === normalizedCategory;
        });
    }

    toggleServiceVisibility(filteredServices) {
        this.allServices.forEach(service => {
            service.element.classList.toggle('hidden', !filteredServices.includes(service));
        });
    }

    filterServices(category) {
        this.updateActiveFilter(category);

        const filteredServices = this.getFilteredServices(category);
        this.toggleServiceVisibility(filteredServices);

        // Handle carousel after DOM updates
        requestAnimationFrame(() => {
            this.handleCarousel(filteredServices.length);
        });
    }

    destroyFlickityInstance(sCarousel) {
        // Destroy stored instance
        if (this.flickityInstance) {
            try {
                this.flickityInstance.destroy();
            } catch (e) {
                // Instance may already be destroyed
            }
            this.flickityInstance = null;
        }

        // Destroy instance attached via GUID
        const guid = sCarousel.flickityGUID;
        if (guid && Flickity.instances?.[guid]) {
            try {
                Flickity.instances[guid].destroy();
            } catch (e) {
                // Instance may already be destroyed
            }
        }
    }

    cleanupFlickityStyles(sCarousel) {
        sCarousel.classList.remove('flickity-enabled');
        sCarousel.removeAttribute('data-flickity');
        sCarousel.style.transform = '';

        Array.from(sCarousel.children).forEach(cell => {
            cell.classList.remove('flickity-cell');
            cell.style.transform = '';
        });
    }

    handleCarousel(visibleCount) {
        const sCarousel = this.carouselContainer?.querySelector('.services-carousel');
        if (!sCarousel) return;

        this.destroyFlickityInstance(sCarousel);
        this.cleanupFlickityStyles(sCarousel);

        if (visibleCount > 4) {
            sCarousel.classList.add('flickity-enabled');
            requestAnimationFrame(() => {
                const guid = sCarousel.flickityGUID;
                const hasInstance = !!(guid && Flickity.instances?.[guid]);

                if (!hasInstance) {
                    this.flickityInstance = createSCarousel(this.carouselContainer);
                }
            });
        }
    }

    initCarousel() {
        const initialCount = this.allServices.length;
        if (this.carouselContainer && initialCount > 4) {
            this.flickityInstance = createSCarousel(this.carouselContainer);
        }
    }

    addListeners() {
        this.filterLinks.forEach(link => {
            link.addEventListener('click', (e) => {
                e.preventDefault();
                this.filterServices(link.dataset.category || 'all');
            });
        });

        if (this.mobileSelect) {
            this.mobileSelect.addEventListener('change', () => {
                this.filterServices(this.mobileSelect.value || 'all');
            });
        }
    }
}

// Initialize all service blocks
const servicesBlocks = document.querySelectorAll('.servicesBlock');

servicesBlocks.forEach(block => {
    new ServiceFilter(block);
});

